window.addEventListener('CookieScriptCategory-functionality', function() {
    document.cookie = "logichop_consent=true; path=/; max-age=2419200; SameSite=Lax";

    // Logic Hop skips initialization when the consent cookie doesn't exist on
    // page load (pid is omitted, so the constructor never runs). Now that
    // consent has been given, manually instantiate and trigger parseLogic so
    // Logic Hop resolves the user's IP/country without a page reload.
    if (typeof window.logichop !== 'undefined') {
        if (typeof window.logichop.parseLogic !== 'function' && typeof LogicHop === 'function') {
            window.logichop = new LogicHop(window.logichop);
            window.logichop.enablePageGoals();
        }

        if (typeof window.logichop.parseLogic === 'function') {
            // Reset loaded flag so the poll waits for the NEW parseLogic
            // AJAX to complete. Without this, loaded is already true from
            // the initial page-load call (which ran without consent, so the
            // server never returned a cookie and conditions can't work).
            window.logichop.data.loaded = false;
            window.logichop.parseLogic();

            // Poll until parseLogic's AJAX completes (sets loaded = true),
            // then notify other scripts that Logic Hop is ready.
            var poll = function (attempts) {
                if (window.logichop.data && window.logichop.data.loaded) {
                    window.dispatchEvent(new Event('logichop-ready'));
                    return;
                }
                if (attempts < 75) {
                    setTimeout(function () { poll(attempts + 1); }, 200);
                }
            };
            poll(0);
        }
    }
});
